var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsisVertical(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ellipsis-vertical_svg__ionicon",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 48
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 416,
    r: 48
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 96,
    r: 48
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisVertical);
export default __webpack_public_path__ + "static/media/ellipsis-vertical.344034c3ad43024b366675d09e1785c9.svg";
export { ForwardRef as ReactComponent };